<template><dk-dashboard /></template>
<script>
import DkDashboard from './dkmall/dashboard/index'
export default { name: 'Index', components: { DkDashboard } }
</script>
